<template>
  <b-modal id="bv-modal-download-app" size="sm" hide-footer>
    <template #modal-header>
      <h4>{{ $t("download-app") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-download-app')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>

    <div>
      <form @submit.prevent>
        <div class="row mb-3" v-if="status">
          <h3 class="text-center">{{ $t("invitation") }}</h3>
          <div class="col-md-12">
            <base-input
              alternative=""
              :label="$t('email')"
              placeholder="jesse@example.com"
              input-classes="form-control-alternative border"
              v-model="email"
              data-vv-validate-on="blur"
              v-validate="'email|required'"
              :data-vv-as="$t('email')"
              name="email"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')"
              ><small>{{ errors.first("email") }}</small></span
            >
          </div>
          <div class="col-md-12 mt-3">
            <b-button
              :disabled="disabled"
              block
              size="sm"
              variant="primary"
              @click="next()"
              >{{ $t("next") }}</b-button
            >
          </div>
        </div>
        <div class="row justify-content-center" v-else>
          <div class="border bg-white">
            <qrcode
              class="mx-auto my-auto"
              :padding="8"
              :size="150"
              cls="qrcode"
              :value="url"
            ></qrcode>
          </div>
          <div class="text-center">
            <h6 class="mt-3">Ó</h6>
            <small class="text-center"
              ><b-link target="_blank" :href="url">{{ url }}</b-link></small
            >
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>
<script>
import Qrcode from "v-qrcode/src/index";
import { mapActions } from "vuex";
export default {
  components: {
    Qrcode,
  },
  data() {
    return {
      url: "https://play.google.com/store/apps/details?id=com.nextstation.mouth2mouth",
      email: "",
      status: true,
      disabled: false,
    };
  },
  methods: {
    ...mapActions({
      preloadReferrer: "user/preloadReferrer",
    }),
    async next() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        if (localStorage.getItem("ref")) {
          const res = await this.preloadReferrer({
            email: this.email,
            referrer: localStorage.getItem("ref"),
          });
        }
        this.status = !this.status;
      }
    },
    showModal(item) {
      this.email = "";
      this.status = true;
      this.$bvModal.show("bv-modal-download-app");
    },
    async add() {},
  },
};
</script>